import React, { Component } from 'react';
import { Field } from 'redux-form';
import * as Form from './formFieldHelpers';
import * as Date from '../dates/dateHelpers';
import DateField from '../dates/dateField';
import * as Buttons from '../ui/buttons';

export default class AwardsForm extends Component {
    componentDidMount() {
        this.handleInitialise();
    }

    handleInitialise = () => {
        const {personId, initialize, id, name, issuer, description, date, person_id, awards} = this.props;

        const month = Date.handleSingleDate(date).month;
        const initialValues = {
            "type": id ? 'UPDATE' : 'CREATE',
            "id": id,
            "person_id": +personId || +person_id || awards.personId,
            "name": typeof name === "string" ? name : "",
            "issuer": issuer,
            "description": description,
            "year": { label: Date.handleSingleDate(date).year, value: Date.handleSingleDate(date).year },
            "month": {label: month && month.name, value: month && month.id},
        };
        initialize(initialValues);
    };

    render() {
        const { buttonHandlers, handleCancel, date, handleAdding } = this.props;
        return (
            <form className="form-standard-profile">
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Name"
                            name="name"
                            placeholder="Name"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Issuer"
                            name="issuer"
                            placeholder="Issuer"
                            component={ Form.textField }
                        />
                    </div>

                    <div className="col-xs-12">
                        <DateField date={date} />

                        <Field
                            label="Description"
                            name="description"
                            placeholder="Description."
                            component={ Form.quill }
                        />
                    </div>
                    <div className="col-xs-12">
                    </div>
                </div>
                <Buttons.HOCFormButtons
                    { ... buttonHandlers }
                    { ...this.props }
                    handleCancel={ handleCancel }
                    handleAdding={ form => handleAdding( form ) } />
            </form>
        )
    }
}





// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/AwardsForm.js